import useSnackInfo from './SnackInfo'
class MetaLicense {
  constructor () {
    this.Unlocked = false
    this.MobileScan = 0
    this.Separation = true
    this.app = null
  }

  parse = (json) => {
    for (const p in json) {
      console.log('Metalicense', p, json[p])
      this[p] = json[p]
    }
  }

  checkSeparation = (mess, showinfo = true) => {
    if (!this.Unlocked && !this.Separation) {
      this.app.ScanSettings.AutoSeparator = false
      this.app.ScanSettings.BarcodeSeparator = false
      this.app.ScanSettings.AutoSinglePageDocuments = false
      this.app.ScanSettings.FileSeparator = true
      if (showinfo) useSnackInfo.info(mess)
    }
  }
}

const useMetaLicense = new MetaLicense()
export default useMetaLicense
